import React, { useEffect, useState } from "react";
import api from "../../api";
import "bootstrap/dist/css/bootstrap.min.css";
import { showSuccessToast, showErrorToast } from "../../utils/toastUtils";
import "react-toastify/dist/ReactToastify.css";
import { TOAST_MESSAGES } from "../../utils/toastMessages";
import { formatDateToUserTimeZone } from "../../utils/formatDate";
// import { formatDateToUserTimeZone } from "../../utils/formatDate";
import axios from "axios";

const TrainingQA = ({ uploadedQuestions = [] }) => {
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [questions, setQuestions] = useState(uploadedQuestions || []);
  const [isAdding, setIsAdding] = useState(false);
  const [isCancelling, setIsCancelling] = useState(false);

  const [summary, setSummary] = useState({
    totalCharacters: 0,
    limit: 12360,
    completion: 0,
  });

  const token =
    localStorage.getItem("access_token") ||
    sessionStorage.getItem("access_token");

  useEffect(() => {
    if (questions.length > 0) {
      const totalChars = questions.reduce(
        (sum, q) =>
          sum + (q.totalCharacters || q.question.length + q.answer.length),
        0
      );

      const limit = 12360; // same as before
      const completion = Math.min(Math.round((totalChars / limit) * 100), 100);

      setSummary({
        totalCharacters: totalChars,
        limit,
        completion,
      });
    }
  }, [questions]);

  const handleAdd = async () => {
    if (!question.trim() || !answer.trim()) {
      showErrorToast(TOAST_MESSAGES.QA_UPLOAD.EMPTY);
      return;
    }

    setIsAdding(true); // ✅ moved after validation

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/uploaded-files/upload/qa`,
        {
          question,
          answer,
          metadata: {
            submitted_by: "admin", // optional metadata
          },
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      showSuccessToast(TOAST_MESSAGES.QA_UPLOAD.SUCCESS);

      const newEntry = {
        question,
        answer,
        totalCharacters: question.length + answer.length,
        updatedAt: new Date().toLocaleString(),
      };

      setQuestions([newEntry, ...questions]);
      setQuestion("");
      setAnswer("");
      fetchQAPairs();
    } catch (err) {
      console.error("Upload error:", err.response?.data || err.message);
      showErrorToast(TOAST_MESSAGES.QA_UPLOAD.ERROR);
    } finally {
      setIsAdding(false);
    }
  };

  const handleCancel = () => {
    setIsCancelling(true);

    setTimeout(() => {
      setQuestion("");
      setAnswer("");
      setIsCancelling(false);
    }, 500); // 2 second simulated delay for feedback
  };

  useEffect(() => {
    fetchQAPairs();
  }, []);

  const fetchQAPairs = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/uploaded-files/qa`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Transform if needed
      const transformed = res.data.map((item) => ({
        question: item.question,
        upload_id: item.upload_id,
        upload_status: item.upload_status ,
        answer: item.answer,
        totalCharacters: item.question.length + item.answer.length,
        updatedAt: item.updated_timestamp
          ? formatDateToUserTimeZone(item.updated_timestamp)
          : "",
      }));

      setQuestions(transformed);

      console.log(transformed,"hdjdfshjjdsf")
    } catch (err) {
      console.error("❌ Error fetching Q&A pairs:", err);
      showErrorToast("Failed to load uploaded Q&A pairs");
    }
  };

  const handleChangeQAStatus = async (uploadId, currentStatus) => {
    console.log(currentStatus)
    const newStatus = currentStatus == "1" ? "0" : "1";

    console.log(uploadId);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/uploaded-files/update_qa_status/${uploadId}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ upload_status: newStatus }),
        }
      );

      const result = await response.json();

      if (!response.ok) {
        showErrorToast(result.message || "Failed to update status");
        return;
      }

      showSuccessToast("Status updated successfully");

      // Refresh your QA list
      fetchQAPairs();
    } catch (err) {
      console.error("Error updating status:", err);
      showErrorToast("Something went wrong");
    }
  };

  return (
    <div
      className="container-fluid mt-2 h-100"
      style={{ paddingBottom: "800px" }}
    >
      <div className="row">
        {/* Q&A Form */}
        <div className="col-lg-8">
          <div className=" p-4 rounded border shadow-sm">
            <label className="form-label fw-semibold">Question</label>
            <div className="mb-3">
              <input
                className="form-control border-1 rounded"
                // style={{ backgroundColor: "#FAF9F9", borderColor: "#3e3e3e" }}
                value={question}
                placeholder="How are you?"
                onChange={(e) => setQuestion(e.target.value)}
                disabled={isAdding} // ✅ disable while adding
              />
            </div>
            <label className="form-label fw-semibold">Answer</label>
            <div className="mb-4">
              <textarea
                rows={3}
                className="input-textarea1 p-2 rounded"
                // style={{ backgroundColor: "#FAF9F9", borderColor: "#3e3e3e" }}
                value={answer}
                placeholder="Enter text..."
                onChange={(e) => setAnswer(e.target.value)}
                disabled={isAdding} // ✅ disable while adding
              />
            </div>
            <div className="d-flex gap-3">
              <button
                className="cancle-btn flex-fill border-1 fw-semibold w-50"
                // style={{ borderColor: "#3e3e3e" }}
                onClick={handleCancel}
                disabled={isCancelling}
              >
                {/* {isCancelling ? <>Cancelling...</> : "Cancel"} */}
                Cancel
              </button>
              <button
                className="custom-btn w-50 fw-semibold text-white"
                // style={{ backgroundColor: "#3e3e3e" }}
                onClick={handleAdd}
                disabled={isAdding}
              >
                {isAdding ? "Uploading..." : "Upload"}
              </button>
            </div>
          </div>

          {/* Table Section */}
          <div className="mt-4">
            <div
              className="table-responsive"
              style={{ maxHeight: "330px", overflowY: "auto" }}
            >
              <table className="table text-left trainingQA-table align-middle">
                <thead className="table-light">
                  <tr>
                    {/* <th>Sr.No.</th> */}
                    <th>Question</th>
                    <th>Answer</th>
                    <th>Total Characters</th>
                    <th>Uploaded On</th>
                     <th>Status</th>
                    {/* <th>Action</th> */}
                  </tr>
                </thead>
                <tbody>
                  {questions.length === 0 ? (
                    <tr>
                      <td colSpan="6" className="text-muted">
                        There are no Q&A entries found in this section.
                      </td>
                    </tr>
                  ) : (
                    questions.map((q, index) => (
                      <tr key={index}>
                        {/* <td>{index + 1}</td> */}
                        <td
                          className="text-truncate"
                          style={{ maxWidth: "300px" }}
                          title={q.question}
                        >
                          {q.question}
                        </td>
                        <td
                          className="text-truncate"
                          style={{ maxWidth: "300px", paddingRight: "40px" }}
                          title={q.answer}
                        >
                          {q.answer}
                        </td>
                        <td>
                          {q.totalCharacters ||
                            q.question.length + q.answer.length}
                        </td>
                        <td>
                          {formatDateToUserTimeZone(
                            q.updatedAt || new Date()
                          )}
                        </td>
                        <td className="text-left">
                          <select
                            className={`badge ${
                              q.upload_status == "1"
                                ? "bg-success"
                                : "bg-danger"
                            }`}
                            value={String(q.upload_status)} // ensure string
                            onChange={(e) =>
                              handleChangeQAStatus(q.upload_id, q.upload_status)
                            }
                          >
                            <option value="1">Approved</option>
                            <option value="0">Rejected</option>
                          </select>
                        </td>
                        {/* <td>
                          <button className="btn btn-sm btn-outline-dark">
                            <i className="bi bi-eye" />
                          </button>
                        </td> */}
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Summary Section */}
        <div className="col-lg-4">
          <div className="card profile p-4 shadow-sm">
            <h5 className="fw-semibold  mb-4">Summary</h5>
            <div className="d-flex justify-content-center align-items-center mb-4 position-relative">
              <svg
                width="140"
                height="140"
                viewBox="0 0 36 36"
                className="circular-chart"
              >
                <path
                  className="circle-bg"
                  d="M18 2.0845
                    a 15.9155 15.9155 0 0 1 0 31.831
                    a 15.9155 15.9155 0 0 1 0 -31.831"
                  fill="none"
                  stroke="#eee"
                  strokeWidth="2"
                />
                <path
                  className="circle"
                  strokeDasharray={`${summary.completion}, 100`}
                  d="M18 2.0845
    a 15.9155 15.9155 0 0 1 0 31.831
    a 15.9155 15.9155 0 0 1 0 -31.831"
                  fill="none"
                  stroke="#3e3e3e"
                  strokeWidth="2"
                />
              </svg>
              <div className="position-absolute text-center">
                <div className=" small">Complete</div>
                <div className="fw-bold fs-2">{summary.completion}%</div>
              </div>
            </div>
            <div className="row text-center mb-4">
              <div className="col">
                <div className=" small fw-semibold">Total Characters</div>
                <div className=" fw-semibold">
                  {summary.totalCharacters.toLocaleString()}
                </div>
              </div>
              <div className="col">
                <div className=" small fw-semibold">Limits</div>
                <div className=" fw-semibold">
                  {summary.limit.toLocaleString()}
                </div>
              </div>
            </div>

            {[
              { type: "Documentation Q&A", value: 80 },
              { type: "Conversational Q&A", value: 60 },
              { type: "Opinion Q&A", value: 40 },
              { type: "List-based Q&A", value: 50 },
              { type: "Folow-up Q&A", value: 70 },
            ].map((doc, idx) => (
              <div key={idx} className="mb-3">
                <div className="d-flex justify-content-between small fw-semibold">
                  <span className="text-secondary">{doc.type}</span>
                </div>
                <div className="progress" style={{ height: "6px" }}>
                  <div
                    className="progress-bar bg-dark"
                    role="progressbar"
                    style={{ width: `${doc.value}%` }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrainingQA;
